import * as React from "react";
import { hexColor } from "./helpers/colorParser";
export class GraphTextObject extends React.PureComponent {
    render() {
        const { xScale, yScale, object, clipId } = this.props;
        const x = xScale(object.coords[0]);
        const y = yScale(object.coords[1]);
        return (React.createElement("g", { clipPath: `url(#${clipId})` },
            React.createElement("text", { transform: `translate(${x} ${y})`, style: { textAnchor: "middle", fill: hexColor(object.color) } }, object.text)));
    }
}
//# sourceMappingURL=GraphTextObject.js.map